import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'

type PropsType = {
  /** Pass through classname to allow styles overrides */
  className?: string
  /** If the users search is for more than one room */
  hasMultipleRooms: boolean
  /** Whether to include the taxes portion of the message */
  includeTaxes: boolean
  /** If supplied it will add the currency code to the message */
  currencyCode?: string
  /** If supplied it will show the PriceMessage */
  showPriceMessage?: boolean
}

export const GuestMessage = styled.span`
  text-transform: lowercase;
  white-space: nowrap;
`

const TaxDisplay = styled.span(
  ({theme}) => css`
    display: inline-block;
    color: ${theme.colors.content.neutral.c600};
    ${theme.typography.text.bodyXS};
    &:first-letter {
      text-transform: capitalize;
    }
  `
)

export const PriceMessageWrapper = styled.span`
  display: inline;
`

const PriceMessage = ({hasMultipleRooms}: {hasMultipleRooms: boolean}) => {
  return hasMultipleRooms ? (
    <FormattedMessageWrapper
      id="nightlyPricePerRoom"
      defaultMessage="Nightly price per room"
    />
  ) : (
    <>
      <FormattedMessageWrapper
        id="nightlyPrice"
        defaultMessage="Nightly price"
      />
    </>
  )
}

export const TaxationAndNightlyPriceMessage = ({
  hasMultipleRooms,
  includeTaxes,
  currencyCode,
  className,
  showPriceMessage = true
}: PropsType) => {
  if (!showPriceMessage && !includeTaxes && !currencyCode) {
    return null
  }

  return (
    <TaxDisplay data-id="NightlyPriceLabel" className={className}>
      {showPriceMessage && (
        <>
          <PriceMessageWrapper>
            <PriceMessage hasMultipleRooms={hasMultipleRooms} />
          </PriceMessageWrapper>
        </>
      )}
      {includeTaxes && (
        <>
          {(showPriceMessage && <>&nbsp;</>) || null}
          <FormattedMessageWrapper
            id="includingTaxes"
            defaultMessage="incl taxes and fees"
          />
        </>
      )}
      {currencyCode && (
        <>
          <>&nbsp;</>
          <FormattedMessageWrapper
            id="inCurrency"
            defaultMessage="in {currencyCode}"
            values={{currencyCode}}
          />
        </>
      )}
    </TaxDisplay>
  )
}
